import { DatePicker, LabelWrapper } from '@gameday/react-components/components'
import { get } from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { date } from 'yup'

import { getMomentDateTime } from '../../../formats'

// use pun to avoid namespace conflicts
const valiDate = date

function Component({
  onChange = () => {},
  date,
  disabled,
  errorText,
  required,
  label,
  name,
  id,
  isSportsTGQuestion,
  dataTestId,
  isToolTip,
  toolTipText,
}) {
  const [error, setError] = useState(errorText)
  const [selectedDate, setSelectedDate] = useState('')

  useEffect(() => {
    if (date !== 'Invalid date') {
      setSelectedDate(
        getMomentDateTime({
          value: moment(date),
          inUTCTimezone: true,
          isDateOnly: true,
        })
      )
    }
  }, [date])

  const dayChange = async chosenDate => {
    await setSelectedDate(
      getMomentDateTime({
        value: chosenDate,
        inUTCTimezone: true,
        isDateOnly: true,
      })
    )
    finalizeDate(chosenDate)
  }

  const validateDate = () => valiDate().typeError('Invalid Date').required('Date is Required')

  const finalizeDate = async selectedDate => {
    try {
      if (isSportsTGQuestion) {
        await validateDate().validate(new Date(selectedDate))
      }
      setError('')
      const date = moment(selectedDate).format('YYYY-MM-DD')
      onChange(date.toString())
    } catch (e) {
      const err = get(e, 'errors[0]')
      setError(err)
    }
  }

  return (
    // biome-ignore lint/complexity/noUselessFragments: TODO
    <>
      <LabelWrapper
        label={label || 'Date'}
        isRequired={required}
        errorText={error || errorText}
        noSpacing
        multipleFields
        name={name}
        isToolTip={isToolTip}
        toolTipText={toolTipText}
      >
        <DatePicker
          startYear={1900}
          endYear={2100}
          withBorder
          disabled={disabled}
          isRequired
          onDateChange={e => dayChange(e)}
          format="DD MMM YYYY"
          fullWidth
          allowEmpty
          selectedDate={selectedDate}
          placeholder="Please Select"
          noMobile={false}
          showInPopup
          id={id}
          dataTestId={dataTestId}
        />
      </LabelWrapper>
    </>
  )
}

export default Component
